export default __webpack_public_path__ + "28b3210a84ff8e80e4b7a0e44a98f1da.jpeg";